import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import SectionHead from '@/components/SectionHead';
import { PHILOSOPHY_VALUES, PHILOSOPHY_STEPS } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

export default function Philosophy() {
  return (
    <section id="philosophy" className="relative py-24 sm:py-32 bg-night-surface border-y border-white/5 overflow-hidden" data-testid="philosophy-section">
      <span className="absolute -top-8 right-0 font-display text-[22vw] leading-none text-stroke-white opacity-[0.06] select-none pointer-events-none" aria-hidden="true">ASA</span>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="02"
          eyebrow="Our Philosophy"
          title={'BUILD THE PLAYER.\nBUILD THE PERSON.'}
          description="Our holistic approach shapes complete athletes on and off the pitch."
          testId="philosophy-heading"
        />

        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="flex flex-wrap gap-3 sm:gap-4"
          data-testid="philosophy-values"
        >
          {PHILOSOPHY_VALUES.map((v, i) => (
            <motion.span
              key={v} variants={fadeUp} custom={i}
              className="gold-hairline rounded-full px-5 sm:px-7 py-2.5 sm:py-3 font-display text-lg sm:text-xl tracking-widest text-brand-goldlight uppercase bg-night/60 hover:bg-brand-gold hover:text-night transition-colors duration-300 cursor-default"
            >
              {v}
            </motion.span>
          ))}
        </motion.div>

        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="mt-16 sm:mt-20 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4"
          data-testid="philosophy-pathway"
        >
          {PHILOSOPHY_STEPS.map((step, i) => (
            <motion.div key={step} variants={fadeUp} custom={i} className="relative">
              <div className={`rounded-sm border p-6 text-center h-full ${i === PHILOSOPHY_STEPS.length - 1 ? 'border-brand-gold/60 bg-brand-gold/10' : 'border-white/10 bg-night/60'}`}>
                <div className="font-display text-sm text-brand-gold tracking-[0.3em]">{String(i + 1).padStart(2, '0')}</div>
                <div className="mt-2 font-display text-2xl sm:text-3xl tracking-wider text-white uppercase">{step}</div>
              </div>
              {i < PHILOSOPHY_STEPS.length - 1 && (
                <ArrowRight size={18} className="hidden lg:block absolute top-1/2 -right-3.5 -translate-y-1/2 text-brand-gold/70 z-10" />
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
